import { BASE_URLS } from 'constants/urls';

export const additionalInfo = `${BASE_URLS.ASSETS}/assets/icon/addition-info.svg`;
export const arrowRightIcon = `${BASE_URLS.ASSETS}/assets/icon/arrow-right.svg`;
export const atSignIcon = `${BASE_URLS.ASSETS}/assets/icon/at-sign.svg`;
export const backIcon = `${BASE_URLS.ASSETS}/assets/icon/back.svg`;
export const briefCaseIcon = `${BASE_URLS.ASSETS}/assets/icon/briefCase.svg`;
export const dateIcon = `${BASE_URLS.ASSETS}/assets/icon/calendar.svg`;
export const chevronDown = `${BASE_URLS.ASSETS}/assets/icon/chevron-down.svg`;
export const chevronLeft = `${BASE_URLS.ASSETS}/assets/icon/chevron-left.svg`;
export const closeXIcon = `${BASE_URLS.ASSETS}/assets/icon/close-x.svg`;
export const closeIcon = `${BASE_URLS.ASSETS}/assets/icon/close.svg`;
export const column = `${BASE_URLS.ASSETS}/assets/icon/column.svg`;
export const column1 = `${BASE_URLS.ASSETS}/assets/icon/column1.svg`;
export const copyIcon = `${BASE_URLS.ASSETS}/assets/icon/copy.svg`;
export const delete01Icon = `${BASE_URLS.ASSETS}/assets/icon/delete-01.svg`;
export const deleteIcon01 = `${BASE_URLS.ASSETS}/assets/icon/delete-icon.svg`;
export const deleteIcon = `${BASE_URLS.ASSETS}/assets/icon/delete.svg`;
export const digitalIcon = `${BASE_URLS.ASSETS}/assets/icon/digital.svg`;
export const disableIcon = `${BASE_URLS.ASSETS}/assets/icon/disable.svg`;
export const disableLtoR = `${BASE_URLS.ASSETS}/assets/icon/disableltor.svg`;
export const downloadCircle = `${BASE_URLS.ASSETS}/assets/icon/download-circle.svg`;
export const edit01Icon = `${BASE_URLS.ASSETS}/assets/icon/edit-01.svg`;
export const editIcon = `${BASE_URLS.ASSETS}/assets/icon/edit.svg`;
export const ellipseIcon = `${BASE_URLS.ASSETS}/assets/icon/ellipse.svg`;
export const emptyIcon = `${BASE_URLS.ASSETS}/assets/icon/empty.svg`;
export const errorFlow = `${BASE_URLS.ASSETS}/assets/icon/error-flow.svg`;
export const expandLess = `${BASE_URLS.ASSETS}/assets/icon/expand-less.svg`;
export const expandMore = `${BASE_URLS.ASSETS}/assets/icon/expand-more.svg`;
export const extendArrow = `${BASE_URLS.ASSETS}/assets/icon/extend-arrow.svg`;
export const extend = `${BASE_URLS.ASSETS}/assets/icon/extend.svg`;
export const eyeIcon = `${BASE_URLS.ASSETS}/assets/icon/eye.svg`;
export const fileTextHalfIcon = `${BASE_URLS.ASSETS}/assets/icon/file-text-half.svg`;
export const fileTextIcon = `${BASE_URLS.ASSETS}/assets/icon/file-text.svg`;
export const filterIcon = `${BASE_URLS.ASSETS}/assets/icon/filter.svg`;
export const numberIcon = `${BASE_URLS.ASSETS}/assets/icon/hash.svg`;
export const horizontalDots = `${BASE_URLS.ASSETS}/assets/icon/horizontaldots.svg`;
export const InfoIcon = `${BASE_URLS.ASSETS}/assets/icon/info.svg`;
export const libraryIcon = `${BASE_URLS.ASSETS}/assets/icon/library.svg`;
export const locationIcon = `${BASE_URLS.ASSETS}/assets/icon/location.svg`;
export const minusDelete = `${BASE_URLS.ASSETS}/assets/icon/minusDelete.svg`;
export const pauseIcon = `${BASE_URLS.ASSETS}/assets/icon/pause.svg`;
export const pencilIcon = `${BASE_URLS.ASSETS}/assets/icon/pencil.svg`;
export const pieGraph = `${BASE_URLS.ASSETS}/assets/icon/pie-graph.svg`;
export const pieGraph2 = `${BASE_URLS.ASSETS}/assets/icon/pie-graph2.svg`;
export const planFailedIcon = `${BASE_URLS.ASSETS}/assets/icon/plan-failed.svg`;
export const planWaitingIcon = `${BASE_URLS.ASSETS}/assets/icon/plan-waiting.svg`;
export const plusCircle = `${BASE_URLS.ASSETS}/assets/icon/plus-circle.svg`;
export const resolutionIcon = `${BASE_URLS.ASSETS}/assets/icon/resolution.svg`;
export const resumeIcon = `${BASE_URLS.ASSETS}/assets/icon/resume.svg`;
export const right01Icon = `${BASE_URLS.ASSETS}/assets/icon/right-01.svg`;
export const rightCheck = `${BASE_URLS.ASSETS}/assets/icon/right-check.svg`;
export const rightTick = `${BASE_URLS.ASSETS}/assets/icon/right-tick.svg`;
export const riskIcon = `${BASE_URLS.ASSETS}/assets/icon/risk.svg`;
export const rupeeIcon = `${BASE_URLS.ASSETS}/assets/icon/rupee.svg`;
export const setting = `${BASE_URLS.ASSETS}/assets/icon/setting.svg`;
export const sliderArrowLeft = `${BASE_URLS.ASSETS}/assets/icon/slider-arrow-left.svg`;
export const sliderArrowRight = `${BASE_URLS.ASSETS}/assets/icon/slider-arrow-right.svg`;
export const stack = `${BASE_URLS.ASSETS}/assets/icon/stack.svg`;
export const trashIcon = `${BASE_URLS.ASSETS}/assets/icon/trash.svg`;
export const textIcon = `${BASE_URLS.ASSETS}/assets/icon/type.svg`;
export const uploadonCloud = `${BASE_URLS.ASSETS}/assets/icon/upload-on-cloud.svg`;
export const upload = `${BASE_URLS.ASSETS}/assets/icon/upload.svg`;
export const excel = `${BASE_URLS.ASSETS}/assets/icon/excel.svg`;
export const uploadBlue = `${BASE_URLS.ASSETS}/assets/icon/upload-blue.svg`;
export const menProfile = `${BASE_URLS.ASSETS}/assets/icon/user.svg`;
export const users01Icon = `${BASE_URLS.ASSETS}/assets/icon/users-01.svg`;
export const vector = `${BASE_URLS.ASSETS}/assets/icon/vector.svg`;
export const verticalDotsIcon = `${BASE_URLS.ASSETS}/assets/icon/vertical-dots.svg`;
export const whatsappIcon = `${BASE_URLS.ASSETS}/assets/icon/whatsapp.svg`;
export const playIcon = `${BASE_URLS.ASSETS}/assets/icon/play.svg`;
export const unsubIcon = `${BASE_URLS.ASSETS}/assets/icon/unsub.svg`;
export const singleUserIcon = `${BASE_URLS.ASSETS}/assets/icon/single-user.svg`;
export const routeIcon = `${BASE_URLS.ASSETS}/assets/icon/route.svg`;
export const clockIcon = `${BASE_URLS.ASSETS}/assets/icon/clock2.svg`;
export const warningExclamationIcon = `${BASE_URLS.ASSETS}/assets/icon/warning-exclamation.svg`;
export const alertTriangleIcon = `${BASE_URLS.ASSETS}/assets/icon/alert-triangle.svg`;
export const checkIcon = `${BASE_URLS.ASSETS}/assets/icon/check.svg`;
export const clockOriginalIcon = `${BASE_URLS.ASSETS}/assets/icon/clock.svg`; // Different name to avoid conflict
export const fullyPaidIcon = `${BASE_URLS.ASSETS}/assets/icon/fully-paid.svg`;
export const greenCheckIcon = `${BASE_URLS.ASSETS}/assets/icon/green-check.svg`;
export const notPaidIcon = `${BASE_URLS.ASSETS}/assets/icon/not-paid.svg`;
export const partiallyPaidIcon = `${BASE_URLS.ASSETS}/assets/icon/partially-paid.svg`;
export const pause1Icon = `${BASE_URLS.ASSETS}/assets/icon/pause1.svg`;
export const refreshIcon = `${BASE_URLS.ASSETS}/assets/icon/refresh.svg`;

export const bargeIcon = `${BASE_URLS.ASSETS}/assets/icon/assets/barge.svg`;
export const autoChurnIcon = `${BASE_URLS.ASSETS}/icon/assets/autochurn.svg`;
